// extracted by mini-css-extract-plugin
module.exports = {"player":"Player_player__z_EHo"};